import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    screenHeader: {
        height: '83px',
        backgroundColor: '#013358',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        position: 'relative',
    },
    asu: {
        position: 'absolute',
        right: '14px',
    },
    title: {
        width: '730px',
        padding: '0px 80px',
        fontSize: '35px !important',
        fontWeight: 'bold !important',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.21,
        letterSpacing: '1.53px',
        textAlign: 'left',
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        left: '20px',
    },
    toggleOrientation: {
        color: 'white',
        background: '#013358',
        height: '83px',
        cursor: 'pointer',
        padding: '10px 10px',
        borderRadius: '0',
    },
    iconsWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: '50px',
        width: '134px',
        justifyContent: 'space-between',
    },
    logos: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '2rem',
        marginLeft: '4rem',
        marginTop: '2.5rem',
    }
})

export default useStyles
